import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { uploadImage, imgSrc, fmtErr } from "./api";

export const UploadField = ({ value, onChange, testid }) => {
    const ref = useRef(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const pick = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        setErr("");
        try {
            onChange(await uploadImage(file));
        } catch (er) {
            setErr(fmtErr(er));
        } finally {
            setBusy(false);
            e.target.value = "";
        }
    };

    return (
        <div>
            <div className="flex flex-col sm:flex-row gap-3">
                <button
                    type="button"
                    onClick={() => ref.current?.click()}
                    disabled={busy}
                    className="inline-flex items-center justify-center gap-2 border-2 border-dashed border-line px-6 py-4 text-base font-semibold text-charcoal hover:border-gold hover:text-gold transition-colors"
                    data-testid={`${testid}-upload-button`}
                >
                    {busy ? <Loader2 size={18} className="animate-spin" /> : <ImagePlus size={18} />}
                    {busy ? "Uploading..." : "Upload Photo from Phone / Computer"}
                </button>
                <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-file-input`} />
            </div>
            <p className="text-xs text-muted mt-2">…or paste an image link below:</p>
            <input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="https://example.com/photo.jpg"
                className="mt-1 w-full border border-line px-4 py-3 text-sm outline-none focus:border-gold"
                data-testid={`${testid}-url-input`}
            />
            {err && <p className="text-sm text-red-600 mt-2">{err}</p>}
            {value && (
                <img src={imgSrc(value)} alt="Preview" className="mt-3 h-36 w-auto object-contain border border-line bg-white p-2" data-testid={`${testid}-preview`} />
            )}
        </div>
    );
};
